import { useEffect, useState } from "react";
import { Badge } from "@/components/ui/badge";
import { api } from "@/lib/api";

interface FlagToggleProps {
  reviewId: string;
  initialFlagged: boolean;
  onChange?: () => void;
}

export function FlagToggle({ reviewId, initialFlagged, onChange }: FlagToggleProps) {
  const [flagged, setFlagged] = useState(initialFlagged);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setFlagged(initialFlagged);
  }, [initialFlagged]);

  const handleClick = async () => {
    if (loading) return;
    const newValue = !flagged;
    setLoading(true);
    setError(null);
    setFlagged(newValue);

    const res = await api(`/admin/reviews/${reviewId}/flag`, {
      method: "PATCH",
      body: JSON.stringify({ flaggedForTakedown: newValue }),
    });

    if (!res.ok) {
      setFlagged(!newValue);
      setError("Update failed");
      setLoading(false);
      return;
    }

    setLoading(false);
    onChange?.();
  };

  return (
    <span className="inline-flex items-center gap-2">
      <Badge
        render={
          <button
            type="button"
            onClick={handleClick}
            disabled={loading}
            aria-pressed={flagged}
            className={
              loading ? "opacity-60" : "cursor-pointer hover:opacity-80"
            }
          />
        }
        variant={flagged ? "destructive" : "outline"}
      >
        {flagged ? "Keep" : "Flag for takedown"}
      </Badge>
      {error && <span className="text-xs text-destructive">{error}</span>}
    </span>
  );
}
